import React from 'react';
import { ClientPortal } from '@/components/client/ClientPortal';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';

export const ClientPortalPage = () => {
  return (
    <ProtectedRoute requiredRole="client">
      <ClientPortal />
    </ProtectedRoute>
  );
};